import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ComplaintContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class Complaint extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Complaint;
  }

  render() {
    return (
      <MasterLayout>
        <ComplaintContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(Complaint);



// WEBPACK FOOTER //
// ./pages/users/Complaint.jsx